var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
export var injectStyleSheet = function (cssText) {
    var style = document.createElement('style');
    style.textContent = cssText;
    style.setAttribute('data-theme', '');
    return document.head.appendChild(style);
};
export var loadStyleSheet = function (source) {
    return new Promise(function (resolve, reject) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = source;
        link.onload = function () {
            resolve(link);
        };
        link.onerror = function () {
            reject(new Error("stylesheet not loaded: ".concat(source)));
        };
        document.head.appendChild(link);
    });
};
export var loadScript = function (source) {
    return new Promise(function (resolve, reject) {
        var script = document.createElement('script');
        script.src = source;
        script.async = true;
        script.onload = function () {
            resolve(script);
        };
        script.onerror = function () {
            reject(new Error("script not loaded: ".concat(source)));
        };
        document.body.appendChild(script);
    });
};
export var copy = function (string) {
    return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, el;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(string)];
                case 1:
                    _b.sent();
                    resolve();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    el = void 0;
                    try {
                        el = document.createElement('textarea');
                        el.value = string;
                        el.setAttribute('readonly', '');
                        el.style.position = 'absolute';
                        el.style.left = '-9999px';
                        document.body.appendChild(el);
                        el.select();
                        document.execCommand('copy');
                        document.body.removeChild(el);
                        resolve();
                    }
                    catch (error) {
                        if (el) {
                            document.body.removeChild(el);
                        }
                        reject(new Error('copy failed'));
                    }
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); });
};
export var scrollToElement = function (target) {
    if (!target)
        return;
    var _a = target.getBoundingClientRect(), top = _a.top, bottom = _a.bottom;
    var isInViewportByY = top >= 0 && bottom <= window.innerHeight;
    if (isInViewportByY)
        return;
    var shouldScrollToBottom = top > window.innerHeight / 2;
    var offset = shouldScrollToBottom
        ? window.pageYOffset + (bottom - window.innerHeight)
        : top + window.pageYOffset - 80;
    try {
        window.scrollTo({
            left: 0,
            top: offset,
            behavior: 'smooth'
        });
    }
    catch (_b) {
        window.scrollTo(0, offset);
    }
};
